import { render, staticRenderFns } from "./square_detail.vue?vue&type=template&id=b9ddf74e&scoped=true"
import script from "./square_detail.vue?vue&type=script&lang=js"
export * from "./square_detail.vue?vue&type=script&lang=js"
import style0 from "./square_detail.vue?vue&type=style&index=0&id=b9ddf74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ddf74e",
  null
  
)

export default component.exports